import { Node } from '@tiptap/core'

export const ChartIntroRow = Node.create({
  name: 'chart_intro_row',

  group: 'chart_intro_row',
  content: 'field_token',      // exactly one token per row
  isolating: true,
  selectable: false,

  addAttributes() {
    return {
      label: { default: '' },  // "Patient Name", "DOB", etc
    }
  },

  parseHTML() {
    return [{ tag: 'chart-intro-row' }]
  },

  renderHTML({ node }) {
    // This wrapper tag won't be visible; it's used by PM.
    return ['chart-intro-row', { 'data-label': node.attrs.label }, 0]
  },

  addNodeView() {
    return ({ node }) => {
      const tr = document.createElement('tr')

      const labelTd = document.createElement('td')
      labelTd.className = 'chart_intro_label'
      labelTd.textContent = node.attrs.label || ''

      const valueTd = document.createElement('td')
      valueTd.className = 'chart_intro_value'

      // 🔑 PM will render the field_token inside here
      const contentDOM = document.createElement('span')
      contentDOM.className = 'chart_intro_value_inner'
      valueTd.appendChild(contentDOM)

      tr.appendChild(labelTd)
      tr.appendChild(valueTd)

      return { dom: tr, contentDOM }
    }
  },
})
